import { useAdminModals } from "@/zustand/store";
import { useGetCardInfoAdmin } from "@/hooks/use-queries";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import moment from "moment";
import { Skeleton } from "@/components/ui/skeleton";

const CardDetails = () => {
  const { cardDetailsData: details } = useAdminModals();
  const { data: cardDetails, isLoading: isLoadingDetails } =
    useGetCardInfoAdmin(details.id);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="fixed inset-0 z-20 flex h-dvh items-center justify-center bg-black/50 backdrop-blur-lg"
    >
      <motion.div
        onClick={(e) => e.stopPropagation()}
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        exit={{ opacity: 0, scale: 0.5 }}
        className="relative h-auto rounded-lg bg-white px-6 py-6 lg:w-120"
      >
        <button
          onClick={() => {
            useAdminModals.setState({
              cardDetailsData: null,
              cardDetailsIsOpen: false,
            });
          }}
          className="hover:text-primary-500 text-primary-500 absolute top-4 right-4"
        >
          <X className="size-5" />
        </button>
        <h2 className="text-xl font-semibold">Card Details</h2>

        <div className="mt-6 grid grid-cols-2 gap-x-4 gap-y-6">
          <div className="flex flex-col">
            <span className="text-xs font-medium">Date & Time</span>
            <span className="text-sm">
              {moment(details?.createTime).format("MMM Do, YYYY hh:mm A")}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-xs font-medium">Card Number</span>
            <span className="text-sm">**** **** **** {details?.last4}</span>
          </div>
          <div className="flex flex-col">
            <span className="text-xs font-medium">User Name</span>
            <span className="text-sm">
              {details?.firstName} {details?.lastName}
            </span>
          </div>
          <div className="flex flex-col">
            <span className={`text-xs font-medium`}>Card Balance</span>
            {isLoadingDetails ? (
              <Skeleton className="h-4 w-20" />
            ) : (
              <span className="text-sm">
                {cardDetails?.data?.balance?.available}{" "}
                {cardDetails?.data?.balance.currency}
              </span>
            )}
          </div>
          <div className="flex flex-col">
            <span className={`text-xs font-medium`}>User Email</span>
            <span className="text-sm">{details?.userEmail || "-"}</span>
          </div>

          <div className="flex flex-col">
            <span className={`text-xs font-medium`}>Card Address</span>
            <span className="text-sm">
              {" "}
              {`${details?.billingAddress?.addressLine1}, ${details?.billingAddress?.city}, ${details?.billingAddress?.state} ${details?.billingAddress?.postalCode}, ${details?.billingAddress?.country}`}
            </span>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default CardDetails;
